import React from "react";
import { FlexColumn } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import { HeaderIcon } from "@/assets/icons";
import cls from "./styles.module.scss";

export const FirstLoader = ({ progress }: { progress: number }) => {
  return (
    <div className={cls.wrapper}>
      <FlexColumn gap={24}>
        <FlexColumn gap={10} alignItems="center">
          <div className={cls.icon}>
            <HeaderIcon />
          </div>

          <FlexColumn gap={4}>
            <Typography className={cls.label}>Богатый Курьер</Typography>
            <Typography className={cls.desc}>Реферальная программа</Typography>
          </FlexColumn>
        </FlexColumn>

        <div className={cls.progresLine}>
          <div className={cls.progresTumb} style={{ width: `${progress}%` }} />
        </div>
      </FlexColumn>
    </div>
  );
};
